export default {
    sortNameTypeMenu: (state) => (type) => {
        const typeMenu = state.tiposCardapios.find(el => el.tipoCardapio === type)

        if (typeof typeMenu !== 'undefined') {
            const sortKey = 'ordenar'
            for (let index = 0; index < typeMenu.categorias.length; index++) {
                typeMenu.categorias[index].produtos = typeMenu.categorias[index].produtos.sort((a, b) => (a[sortKey] > b[sortKey]) ? 1 : (a[sortKey] < b[sortKey]) ? -1 : 0)
            }
        }

        return typeMenu
    }
}